
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import QuestionBankDropdown from "@/components/shared/QuestionBankDropdown";
import DifficultyDropdown from "@/components/shared/DifficultyDropdown";

const FiltersSidebar = ({ 
  questionFilters, 
  setQuestionFilters, 
  setQuestionPage,
  categoriesData,
}) => {
  const clearAllFilters = () => {
    setQuestionFilters({
      search: "",
      questionBankIds: [],
      difficulties: [],
      tags: ""
    });
    setQuestionPage(1);
  };

  const handleQuestionBankChange = (selectedBankIds) => {
    setQuestionFilters((prev) => ({
      ...prev,
      questionBankIds: selectedBankIds
    }));
    setQuestionPage(1);
  };

  const handleDifficultyChange = (selectedDifficulties) => {
    setQuestionFilters((prev) => ({
      ...prev,
      difficulties: selectedDifficulties
    }));
    setQuestionPage(1);
  };

  return (
    <div className="w-80 border-r bg-gray-50/50 h-full flex flex-col">
      <Card className="border-0 bg-transparent shadow-none flex-1 flex flex-col">
        <CardHeader className="pb-4 flex-shrink-0">
          <div className="flex justify-between items-center">
            <CardTitle className="text-lg">Filters</CardTitle>
            <Button variant="outline" size="sm" onClick={clearAllFilters}>
              Clear All
            </Button>
          </div>
        </CardHeader>
        <CardContent className="flex-1 overflow-hidden">
          <ScrollArea className="h-full pr-4">
            <div className="space-y-6">
              {/* Search Section */}
              <div className="space-y-4">
                <div className="space-y-2">
                  <Label className="text-sm font-medium">Search Questions</Label>
                  <div className="relative">
                    <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-500" />
                    <Input
                      placeholder="Search questions..."
                      className="pl-8"
                      value={questionFilters.search}
                      onChange={(e) => {
                        setQuestionFilters((prev) => ({
                          ...prev,
                          search: e.target.value,
                        }));
                        setQuestionPage(1);
                      }}
                    />
                  </div>
                </div>
                <div className="space-y-2">
                  <Label className="text-sm font-medium">Search by Tags</Label>
                  <div className="relative">
                    <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-500" />
                    <Input
                      placeholder="Search by tags..."
                      className="pl-8"
                      value={questionFilters.tags}
                      onChange={(e) => {
                        setQuestionFilters((prev) => ({
                          ...prev,
                          tags: e.target.value,
                        }));
                        setQuestionPage(1);
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Dropdown Filters */}
              <div className="space-y-4">
                <div className="space-y-2">
                  <Label className="text-sm font-medium">Question Banks</Label>
                  <QuestionBankDropdown
                    selectedBankIds={questionFilters.questionBankIds}
                    onSelectionChange={handleQuestionBankChange}
                    userQuestionBanks={categoriesData?.data?.userQuestionBanks || []}
                    companyQuestionBanks={categoriesData?.data?.companyQuestionBanks || []}
                    placeholder="Select Question Banks..."
                    multiple={true}
                  />
                </div>
                <div className="space-y-2">
                  <Label className="text-sm font-medium">Difficulty Levels</Label>
                  <DifficultyDropdown
                    selectedDifficulties={questionFilters.difficulties}
                    onSelectionChange={handleDifficultyChange}
                    placeholder="Select Difficulties..."
                    multiple={true}
                  />
                </div>
              </div>
            </div>
          </ScrollArea>
        </CardContent>
      </Card>
    </div>
  );
};

export default FiltersSidebar;
